import { useVenueContext } from "contexts/VenueContext";
import { useCallback } from "react";

import { VenueSelectProps } from "./types";

import VenueSelect from ".";

const VenueContextSelect: React.FC<
  Omit<VenueSelectProps, "value" | "onChange">
> = (props) => {
  const { venue, setVenue } = useVenueContext();
  const onChange = useCallback<
    Exclude<VenueSelectProps["onChange"], undefined>
  >((value) => setVenue(value || undefined), [setVenue]);

  return <VenueSelect value={venue} {...{ ...props, onChange }} />;
};

export default VenueContextSelect;
